import { render, staticRenderFns } from "./CommoditiesByInvesting.vue?vue&type=template&id=6447c582&"
import script from "./CommoditiesByInvesting.vue?vue&type=script&lang=js&"
export * from "./CommoditiesByInvesting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports